import { render, staticRenderFns } from "./MailsIcon.vue?vue&type=template&id=775aaffb&"
import script from "./MailsIcon.vue?vue&type=script&lang=ts&"
export * from "./MailsIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports